import React from 'react';
import PropTypes from 'prop-types';
import Logo from '../components/Logo/Logo';


const BasicTemplate = function BasicTemplateComponent(props) { // eslint-disable-line
  const {
    logo,
    contact,
    links,
    disclaimer,
  } = props;

  const orderedLinks = links.sort((linkA, linkB) => linkA.sort - linkB.sort);

  return (
    <div className="se-tier">
      <div className="basic-temp__wrapper">
        <div className="se-container">
          <div className="basic-temp">
            <div className="basic-temp__contact">
              {contact.supportingText && (
                <span className="basic-temp__contact__supporting-text">
                  {`${contact.supportingText} `}
                </span>
              )}
              <a
                className="basic-temp__contact__link"
                href={contact.url}
              >
                {contact.display}
              </a>
            </div>

            <ul className="basic-temp__link-list">
              {orderedLinks.map(link => (
                <li
                  className="basic-temp__link-list__item"
                  key={link.id}
                >
                  <a
                    href={link.url}
                    className="basic-temp__link"
                    target={link.external ? '_blank' : '_self'}
                  >
                    {link.display}
                  </a>
                </li>
              ))}
            </ul>
            <Logo {...logo} />
          </div>
          {disclaimer && (
            <div className="basic-temp__disclaimer">
              {disclaimer}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

BasicTemplate.propTypes = {
  logo: PropTypes.shape({
    image: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    href: PropTypes.string,
  }).isRequired,
  contact: PropTypes.shape({
    url: PropTypes.string.isRequired,
    display: PropTypes.string.isRequired,
    supportingText: PropTypes.string,
  }).isRequired,
  links: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    display: PropTypes.string.isRequired,
    sort: PropTypes.number.isRequired,
    external: PropTypes.bool.isRequired,
  })).isRequired,
  disclaimer: PropTypes.string,
};

BasicTemplate.defaultProps = {
  disclaimer: null,
};

export default BasicTemplate;
